import * as actionTypes from "../actionTypes";
import uuid from "uuid";

export function addTiles(tiles) {
	const mappedTiles = tiles.map(tile => ({
		...tile,
		__id: uuid.v4(),
	}));

	return {
		type: actionTypes.TILE_ADD_MULTIPLE,
		tiles: mappedTiles,
	};
}

export function removeTiles(tileIds) {
	return {
		type: actionTypes.TILE_REMOVE_MULTIPLE,
		tileIds,
	};
}

export function setTileLoaded(tileId, loaded) {
	return {
		type: actionTypes.TILE_SET_LOADED,
		tileId,
		loaded,
	};
}
